import { DateTime } from 'luxon';
import * as Constants from '../Constants';

class EventStatus {

  static eventList = {};

  static getEventStatus(event) {
    let result = Constants.EVENT_NOT_READY;
    
    // 1. Initialize Luxon DateTime objects
    const now = DateTime.now();
    const shownOn = DateTime.fromISO(event.shownOn);
    
    // 2. Calculate delta in milliseconds
    // In Luxon, subtracting results in a Duration object, 
    // so we use .toMillis() for direct math comparison.
    const delta = shownOn.toMillis() - now.toMillis();
    
    const lastStatus = EventStatus.eventList[event._id];
    
    if (lastStatus === Constants.EVENT_CANCELLED) {
      return lastStatus;
    }

    if (delta > 0) {
      // Event in the future
      if (delta <= Constants.PRE_START_MINUTES * Constants.MS_MINUTE) {
        // Event is near in the future, about to start
        result = Constants.EVENT_ABOUT_TO_START;
      } else {
        // Event is farther out in the future
        result = Constants.EVENT_NOT_READY;
      }
    } else {
      // Event in the past (delta is negative or zero)
      if (delta <= -1 * Constants.MAX_EVENT_MINUTES * Constants.MS_MINUTE) {
        // Event is too far out in the past
        result = Constants.EVENT_NOT_READY;
        delete EventStatus.eventList[event._id];
      } else if (lastStatus) {
        result = lastStatus;
      } else {
        // We begin in the stopped state
        result = Constants.EVENT_STOPPED;
        EventStatus.eventList[event._id] = result;
      }
    }
    
    return result;
  }

  static setEventStatus(event, status) {
    const lastStatus = EventStatus.getEventStatus(event);
    if (lastStatus === Constants.EVENT_NOT_READY) {
      throw new Error("cant set status to " + status + " event is NOT READY");
    }
    if (status === Constants.EVENT_STARTED || status === Constants.EVENT_STOPPED ||
            status === Constants.EVENT_CANCELLED || status === Constants.EVENT_SHOW_URL || status === Constants.EVENT_TELECON_STARTED ||
            status === Constants.EVENT_BINGO_BALL || status === Constants.EVENT_BINGO_GAME) {
      if (lastStatus === Constants.EVENT_ABOUT_TO_START) {
        throw new Error("cant set status to " + status + " event is ABOUT TO START");
      }
      EventStatus.eventList[event._id] = status;
    } else {
      throw new Error("cant set status to " + status + " unknown status");
    }
  }
}

export default EventStatus;
